import { FC, memo } from "react";

import { AvatarSmart } from "@/components/_atoms/avatar-smart";

import { Workspace } from "../models/workspace-model";

const AVATAR_FALLBACK_BACKGROUND_COLOR = "rgb(154 94 0)";

export interface AvatarWorkspaceProps {
  workspace: Workspace;
  className?: string;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  showBorder?: boolean;
  shape?: "rounded" | "square";
}

export const AvatarWorkspace: FC<AvatarWorkspaceProps> = memo(
  ({ className, workspace, size = "sm", showBorder = false, shape = "square" }) => {
    if (!workspace) {
      return <></>;
    }

    return (
      <AvatarSmart
        src={workspace.logo || undefined}
        fallback={
          <div
            className="flex h-full w-full items-center justify-center font-semibold text-white"
            style={{ backgroundColor: AVATAR_FALLBACK_BACKGROUND_COLOR }}
          >
            {workspace.name.slice(0, 2).toUpperCase()}
          </div>
        }
        className={className}
        size={size}
        shape={shape}
        showBorder={showBorder}
      />
    );
  },
);

AvatarWorkspace.displayName = "AvatarWorkspace";
